/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */

import { Grid } from "antd";
import React from "react";
import DesktopMenu from "./DesktopMenu";

// Children menu
export const ChildrenMenu = (props) => {
  const { isVisible } = props;
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { xl } = screens;
  
  // Always render but control visibility for animations
  if (!xl || !isVisible) {
    return <div className="invisible h-0" />;
  }
  
  return <DesktopMenu {...props} />;
};

export default ChildrenMenu;
